const AIRCALL_BASE_URL = '/v1/integrations/aircall';

const AIRCALL_API_ENDPOINTS = {
  SETUP: `${AIRCALL_BASE_URL}/setup`,
  TOGGLE_AUTH: `${AIRCALL_BASE_URL}/toggle_auth`,
  USER_DETAILS: `${AIRCALL_BASE_URL}/current_user`,
  PHONE_NUMBERS: `${AIRCALL_BASE_URL}/phone_numbers`,
  AUTH_USER: `${AIRCALL_BASE_URL}/auth_user`,
};

const AIRCALL_ENABLED = 1;

const AIRCALL = 'AIRCALL';

const AIRCALL_LOGOUT_MODAL_TEXT = {
  TITLE: 'Are you sure you want to disable Aircall Integration?',
  MESSAGE: 'Please note your Aircall account will be unlinked from this voice inbox.',
};

export {
  AIRCALL_ENABLED,
  AIRCALL_API_ENDPOINTS,
  AIRCALL,
  AIRCALL_LOGOUT_MODAL_TEXT,
};
